import { CoralogixRum } from '@coralogix/browser';
import log from 'loglevel';

declare const __APP_VERSION__: string;
if (typeof window !== 'undefined') {
  (window as any).__APP_VERSION__ = __APP_VERSION__;
}
log.info(__APP_VERSION__);
CoralogixRum.init({
  stringifyCustomLogData: true,
  environment: process.env.NODE_ENV || 'development',
  public_key: import.meta.env.VITE_CORALOGIX_RUM_TOKEN || '',
  application: 'fly_ui',
  version: __APP_VERSION__ || '1.0',
  coralogixDomain: 'US1',
});
